import $ from 'jquery';
import 'slick-carousel/slick/slick.min.js';


$(document).ready(function () {
    let interval = $('.section_home_carousel').attr('data-interval');
    let autoplay = interval == '0' ? false : true;
    let count = $('.slick_list').attr('data-count');
    let hidePartBtn = $('.slick_list_carousel').attr('data-hidePartBtn')
    let hideType = $('.slick_list_carousel').attr('data-hideType')
    $('.carousel_slick_content').css('display','block')
    $(".slick_list").not('.slick-initialized').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        centerMode: true,
        variableWidth: true,
        adaptiveHeight:true
    });
    $('.slick_list_carousel').not('.slick-initialized').slick({
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay,
        autoplaySpeed: interval * 1000,
        prevArrow: "<button class='iconfont slick-prev main_button'>&#xe64f;</button>",
        nextArrow: "<button class='iconfont slick-next main_button'>&#xe64b;</button>",
    });
    if(count<2){
        $('.slick_list .slick-dots').css('display','none')
    }
    const carouselImg = $('.slick_list_carousel>.slick-list>.slick-track>.slick-img');
    carouselImg.css("cssText", `width:${100 / carouselImg.length}% !important`)
    $('div.section.section_home_carousel > div > div > div > div').css("cssText", `min-width:${carouselImg.length * 100}% !important;`)

    const collectionList = $('.collection_list>.slick_list> div > div>.slick-slide')
    collectionList.css("cssText", `width:${100 / collectionList.length}% !important;`)
    $('.collection_list>.slick_list> div > div').css("cssText", `min-width:${91.94444 * collectionList.length}% !important;`)

    const hotSalesList = $('.hotSales_list>.slick_list> div > div>.hotSales_list_items')
    hotSalesList.css("cssText", `width:${100 / hotSalesList.length}% !important;`)
    $('.hotSales_list>.slick_list> div > div').css("cssText", `min-width:${91.94444 * hotSalesList.length}% !important;`)
    
    if($('.slick_list_carousel .slick-dots li').length<=1){
        $('.slick_list_carousel .slick-dots li').css('display','none')  
    }

    if(hidePartBtn && hideType=='square'){
        $('.slick-dots').css('display','none')
    }
    if(hidePartBtn && hideType=='arrow'){
        $('.slick-prev').css('display','none')
        $('.slick-next').css('display','none')
    }

    if (window.location.search) {
        let search = window.location.search.split("?")[1];
        if (search && search.includes('customer_posted=true')) {
            $('.subscribe .subscribe_letter ').hide();
            $('.subscribe .thank_subscribe ').show();
        }
    }
})
window.subscribe = async function (e) {
    e = e || window.event;
    console.log(e);
    e.preventDefault();
    try {
        let email = $('#Email').val();
        let res = await $.post('/api/contacts',{email});
        $('.subscribe .subscribe_letter ').hide();
        $('.subscribe .thank_subscribe ').show();
        if(res&&res.challenge){
            sessionStorage.setItem('challenge',JSON.stringify(res))
            window.open('/challenge','_self');
          }else{
            window.history.replaceState({}, "", "?customer_posted=true");
          }
    } catch (error) {
        return false;
    }
}


